module.exports = __webpack_public_path__ + "2e12a0051db384fafebca8223ac9f835.svg";